import { render, staticRenderFns } from "./group-progress-chart.vue?vue&type=template&id=a2940100&scoped=true"
import script from "./group-progress-chart.vue?vue&type=script&lang=js"
export * from "./group-progress-chart.vue?vue&type=script&lang=js"
import style0 from "./group-progress-chart.vue?vue&type=style&index=0&id=a2940100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2940100",
  null
  
)

export default component.exports